import { ca } from '@cian/analytics';

import { IJsonQuery } from 'shared/json_query';

interface IParams {
  jsonQuery: IJsonQuery;
  offerId: number;
  position: number;
}

export const trackAutoZoom = ({ jsonQuery, offerId, position }: IParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show',
    label: 'autozoom',
    sc: jsonQuery,
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
};
